export default {
  header: 'Vytvoriť jednorazový diel',
  subHeader: 'Vytvorte jednorazový diel na použitie v správe o kvalite',
};
